<script>
    import EventMixin from '../../mixins/EventMixin';
    export default {
        props: {
            value: {
                default: ''
            },
            name: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                required: false
            },
            focus: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: Number,
                required: false
            },
            autocomplete: {
                type: String,
                require: false
            },
            initialValue: {
                type: [String, Number],
                default: ''
            },
            placeholder: {
                type: String,
                required: false
            },
            errors: {
                type: Object,
                required: true
            },
            showValidation: {
                type: Boolean,
                default: true
            },
            validation: {
                type: Object,
                required: false
            },
            validationDisplayClass: {
                type: String,
                default: ''
            },
            listenEvent: {
                type: String,
                required: false
            },
            fireEvent: {
                type: String,
                required: false
            },
            inputEvent: {
                type: String,
                required: false
            },
            postSubmitClear: {
                type: String,
                default: ''
            },
            visible: {
                type: Boolean,
                default: true
            },
            wrapperCssClass: {
                type: String,
                required: false
            },
            cssClass: {
                type: String,
                required: false
            },
            cssStyle: {
                type: String,
                required: false
            },
            updateEvent: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                show: this.visible
            }
        },
        computed: {
            invalidClass() {
                return [
                    {
                        invalid: this.errors.has(this.name)
                    },
                    this.cssClass
                ];
            },
            postSubmitEvent() {
                return (new EventMixin(this.postSubmitClear)).target('success');
            }
        },
        created() {
            if (this.postSubmitClear) {
                EventBus.listen(this.postSubmitEvent, this.clear);
            }
        },
        methods: {
            update(value) {
                if (this.inputEvent) {
                    EventBus.fire(this.inputEvent, value);
                }
                this.$emit('input', value);
            },
            clear() {
                this.update('');
            }
        }
    }
</script>